import { BaseAssertException } from '../exceptions/base-assert.exception';
import { Matcher } from '../matchers/base.matcher';
import { nonNullable } from './non-nullable.assert';

export function that<T>(
  value: T,
  matcher: Matcher<T>,
  construct: new (message: string) => BaseAssertException,
): asserts value is NonNullable<T> {
  nonNullable(value, () => 'value must be defined', construct);
  nonNullable(matcher, () => 'matcher must be defined', construct);

  const passed = matcher.apply(value);
  if (!passed) {
    throw new construct(matcher.message());
  }
}
